var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M14.537 6.694H14v-.027H8v2.666h3.767A3.998 3.998 0 0 1 4 8a4 4 0 0 1 4-4c1.02 0 1.947.385 2.653 1.013l1.886-1.886a6.64 6.64 0 0 0-4.54-1.794 6.667 6.667 0 1 0 6.538 5.361"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "m2.102 4.897 2.19 1.606A4 4 0 0 1 8 4c1.02 0 1.947.385 2.653 1.013l1.886-1.886a6.64 6.64 0 0 0-4.54-1.794 6.66 6.66 0 0 0-5.897 3.564"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M8 14.667a6.64 6.64 0 0 0 4.47-1.731l-2.063-1.746A3.97 3.97 0 0 1 8 12a4 4 0 0 1-3.76-2.649l-2.175 1.675A6.66 6.66 0 0 0 8 14.666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M14.537 6.694H14v-.027H8v2.666h3.768a4 4 0 0 1-1.363 1.857h.001l2.064 1.746c-.146.132 2.197-1.603 2.197-4.936a6.7 6.7 0 0 0-.13-1.306"
  })));
};
export default SvgGoogle;